import { ErrorBoundary as SentryErrorBoundary } from '@sentry/gatsby'
import { ReactNode } from 'react'

import { useTranslation } from '../translations'

import ErrorFallback from './ErrorFallback'

const ErrorBoundary = ({ children }: { children: ReactNode }) => {
  const t = useTranslation('sentry')
  return (
    <SentryErrorBoundary
      fallback={<ErrorFallback />}
      showDialog
      dialogOptions={{
        ...t,
      }}
    >
      {children}
    </SentryErrorBoundary>
  )
}

export default ErrorBoundary
